window.actualizarZonaTrabajo = null;

if (window.location.pathname === "/zona-trabajo") {
    
    // Configuración de las opciones de la solicitud
    const requestOptions = {
        method: "GET",
        credentials: "include", // Incluye las cookies automáticamente
        headers: {
            "Content-Type": "application/json", // Si es necesario especificar un tipo de contenido
        },
        redirect: "follow",
    };

    const contArticulos = document.querySelector("#contArticulosTrabajos");

    window.actualizarZonaTrabajo = () => {

        const url = `/api/zona-trabajo`;

        if (contArticulos.innerHTML.trim() === "") {
            const skeletonItem = `
                <article class="cardTrabajoSkeleton">
                    <div class="skHeader">
                        <div class="skeleton skEstado"></div>
                        <div class="skHorario">
                            <div class="skeleton skAncho100"></div>
                            <div class="skeleton skAncho60"></div>
                            <div class="skeleton skAncho60"></div>
                        </div>
                    </div>
                    <div class="skMain">
                        <div class="skeleton skFoto"></div>
                        <div class="skInfo">
                            <div class="skeleton skAncho100"></div>
                            <div class="skeleton skAncho70"></div>
                            <div class="skeleton skAncho50"></div>
                        </div>
                    </div>
                    <div class="skFooter">
                        <div class="skProgreso">
                            <div class="skeleton skAncho5r"></div>
                            <div class="skeleton skAncho8r"></div>
                        </div>
                        <div class="skeleton skBoton"></div>
                    </div>
                </article>
            `;
            contArticulos.innerHTML = skeletonItem.repeat(3);
        }

        function f(numero) {
            if (numero === null || numero === undefined || isNaN(numero)) return 0;
            return Number(numero).toLocaleString('en-US');
        }
        const int = n => (Number(n) || 0);
        const num = n => (Number(n) || 0).toLocaleString('en-US');
        const numCero = n => (Number(n) || "").toLocaleString('en-US');
        const fecha = (f) => f.split('-').reverse().join('/');
        const txt = t => String(t ?? '').trim();
        const idReporte = item => item.idEncabezadoReporte
            ?? item.idencabezadoreporte
            ?? item.idEncabezadoReporteAcondicionamiento
            ?? item.idencabezadoreporteacondicionamiento
            ?? 0;
        const formatText = (str) => {if (!str || str.trim() === "") return "-"; return String(str)};
        const hora = h24 => {
            if (!h24) return '-';
            let [h, m] = h24.split(':');
            return `${h % 12 || 12}:${m} ${h < 12 ? 'a.m.' : 'p.m.'}`;
        };
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                contArticulos.innerHTML = "";
                const data = result.result.trabajosAsignados;

                let htmlArticulos = "";
                data.forEach(item => {
                    
                    let txtEstado = "";
                    let claseCard = "";
                    let claseBtn = "";

                    if (int(item.undBueno) === 0 && int(item.estado) === 1) {
                        txtEstado = "SIN INICIAR";
                        claseCard = "cardTrabajoRojo";
                        claseBtn = "btnIconAzulTxtBlanco";
                    }
                    if (int(item.undBueno) > 0 && int(item.estado) === 1) {
                        txtEstado = "EN PROCESO";
                        claseCard = "cardTrabajoVerde";
                        claseBtn = "btnIconAzulTxtBlanco";
                    }
                    if (int(item.estado) === 2) {
                        txtEstado = "FINALIZADO";
                        claseCard = "cardTrabajoGris";
                        claseBtn = "btnIconBlancoTxtGris";
                    }

                    let modalReporte = 'modalProduccionInyeccion';
                    if (item.Area === 'SOPLADO') modalReporte = 'modalProduccionSoplado';
                    if (item.Area === 'ACONDICIONAMIENTO') modalReporte = 'modalProduccionAcondicionamiento';

                    htmlArticulos += `
                        <article class="${claseCard}">
                            <div class="headerArticule">
                                <div class="estado">
                                    <div class="ledEstado"></div>
                                    <p class="pEstado">${txtEstado}</p>
                                </div>
                                <div class="horario">
                                    <p class="turno">${item.nombreTurno}</p>
                                    <p class="fechaHora"><strong>Fecha: </strong>${fecha(item.fechaCreacionTurno)}</p>
                                    <p class="fechaHora"><strong>Inicio: </strong> ${hora(item.horaInicio)}</p>
                                    <p class="fechaHora"><strong>Fin: </strong> ${hora(item.horaFin)}</p>
                                </div>
                            </div>
                            <div class="mainArticulo">
                                <div class="imgArticulo">
                                    <img src="/public/uploads/usuarios/${item.fotoUsuario}?v=${Date.now()}" alt="foto operario">
                                </div>
                                <div class="infoMain">
                                    <div class="infoOperario">
                                        <p class="cargo">${txt(item.Area)}</p>
                                        <p class="nombreOperario">${txt(item.nombreOperario)}</p>
                                    </div>
                                    <div class="infoArea">
                                        <p><strong>Área: </strong>${txt(item.Area)}</p>
                                        <p><strong>Zona: </strong>${txt(item.nombreZona)}</p>
                                        <p><strong>Maquina: </strong> ${txt(item.nombreMaquina)}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="footerArticule">
                                <div class="progreso">
                                    <p><strong>Produccion</strong></p>
                                    <p class="pProgreso">${num(item.undBueno)} / ${num(item.undTurno)}</p>
                                    <p>Und producidas</p>
                                </div>
                                <div class="contBtnArticule">
                                    <button class="${claseBtn} btnModal btnVerReporte" data-id="${int(idReporte(item))}" data-modal="${modalReporte}">
                                        Abrir reporte
                                        <img src="/public/build/img/icons/flecha-derecha.svg" alt="">
                                    </button>
                                </div>
                            </div>
                        </article>
                    `;

                });

                if (data.length === 0) {
                    contArticulos.innerHTML = `
                        <div class="sinTrabajosAsignados">
                            <p>No tienes trabajos asignados.</p>
                        </div>
                    `;
                    return;
                }

                contArticulos.innerHTML = htmlArticulos;

            })
            .catch((error) => {
                console.error("Error en la solicitud:", error);
                alert("Ocurrio un error en zona trabajo, contactar al administrador.");
                return;
            });
    };

    if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();

    setInterval(() => {
        if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
    }, 120000);
}
